import React from 'react';
import {TagSmall} from '@wix/wix-ui-icons-common';
import {useControllerProps} from '../../../../../../../domain/controllers/ControllerContext';
import s from './FreeShippingCoupon.scss';

export enum FreeShippingCouponDataHook {
  Root = 'FreeShippingCoupon.Root',
  Icon = 'FreeShippingCoupon.Icon',
  Name = 'FreeShippingCoupon.Name',
}

export const FreeShippingCoupon = () => {
  const {cartSummary} = useControllerProps().cartStore;

  const freeShippingDiscount = cartSummary?.deliveryDiscounts[0];

  if (!freeShippingDiscount) {
    return null;
  }

  return (
    <div data-hook={FreeShippingCouponDataHook.Root} className={s.root}>
      <TagSmall aria-hidden data-hook={FreeShippingCouponDataHook.Icon} className={s.icon} />
      <span data-hook={FreeShippingCouponDataHook.Name}>{freeShippingDiscount.name}</span>
    </div>
  );
};
